module.exports = __webpack_public_path__ + "img/tema-3-7.0a6bc3af.gif";